// #region Imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  ActionBar,
  ActionBarRow,
  CheckboxFilter,
  HitsStats,
  InitialLoader,
  Layout,
  LayoutBody,
  LayoutResults,
  MenuFilter,
  NoHits,
  PageSizeSelector,
  Pagination,
  Panel,
  RangeFilter,
  RangeSliderInput,
  RefinementListFilter,
  ResetFilters,
  SearchkitManager,
  SearchkitProvider,
  Select as SearchKitSelect,
  SelectedFilters,
  SortingSelector,
  ViewSwitcherHits,
} from 'searchkit';
import WishlistButton from './wishlist/WishlistButton';
import Select from 'react-select';
import { find, findIndex, get, uniqBy, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import {
  loadAggregationsES,
  loadAttributes,
  loadCategories,
  loadMarketplaces,
  loadUserSelectedDistance,
  loadUserSelectedLocation,
} from '../actions';
import {
  commafy,
  commafyCurrency,
  findStateAbbreviation,
  getConfig,
  findDistanceUnits,
} from '../utils/helpers';
import { mpSortOptionsMap, mpSearchColumnsMap, ES_MAX_DISTANCE } from '../utils/constants';
import SelectedFilterCustom from './search/SelectedFilterCustom';
import HitStatsCustom from './search/HitStatsCustom';
import NoHitsDisplayCustom from './search/NoHitsDisplayCustom';
import ResetFiltersDisplayCustom from './search/ResetFiltersDisplayCustom';
import ListItem from './search/ListItem';
import '../assets/css/searchkit-custom.css';
import '../assets/css/geoSuggest.css';
import { postStratosMessage } from '../utils/widgets';
import Geosuggest from 'react-geosuggest';
import { RangeSliderInputCustom } from './search/RangeSliderInputCustom';
// import { StratosLoaderDummyData } from './common/vehicleValues/StratosLoaderData';
// #endregion Imports

// #region Globals
const todayDateText = moment().format("YYYY-MM-DD");
const mpSortColumnsFallback = '1';
const searchRoot = getConfig('searchRoot');
const dropdownStyle = {
  control: base => ({
    ...base,
    border: '1px solid #E8E8E8',
    boxShadow: 0,
    '&:hover': {
      border: '1px solid #E8E8E8',
    },
    fontSize: '16px',
  }),
  singleValue: base => ({
    ...base,
    color: '#787878',
  }),
  option: base => ({
    ...base,
    cursor: 'pointer',
    color: '#787878',
    borderBottom: '1px solid #EAEAEA',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
    fontSize: '16px',
  }),
};
// #endregion Globals
/**
 * Enabled via **AWG**: _Setup Marketplaces_ -> _Web/Mobile_
 *   - **Custom fields**:
 *     - `"displayRecommendedContent": true`
 *   - Adds/Removes a `"message"` listener which executes searches
 *     - _Note: currently limited to `make` and `model`_
 * @description Search-like page with Darwin Dealer Intelligence integration.
 */
class Recommended extends Component {
  constructor(props) {
    super(props);
    const isMobileDevice = window.matchMedia('(max-width: 800px)').matches;
    // Note:  disabling until buyer intelligence and vehicle values can work simultaneously
    // const stratosConfig = getConfig('stratosConfig');
    // const showVehicleValuesButton = !!(stratosConfig && stratosConfig.dealerGuid && stratosConfig.scriptSrc);
    this.state = {
      isMobileDevice,
      userSelectedDistance: props.userSelectedDistance || ES_MAX_DISTANCE,
      dropdownSelectedDistance: undefined,
      listingStatusIds: props.listingStatusIds,
      search: '',

      staticAggregations: undefined,
      staticFilterList: undefined,
      staticSortOptions: undefined,

      defaultSortOption: undefined,
      showDealerPanel: true,

      /* Default to 'list' view if on Mobile device */
      showRecommendedResults: false,
      defaultView: 'list',
      page: undefined,

      /* Vehicle Values */
      isInitialLoaderRefreshed: false,
      showVehicleValuesButton: false,

      /* Dealer Intelligence */
      recommendedMake: '',
      recommendedModel: '',

      /* Filter panels - hide | show */
      isTrimFilterHidden: false,
      isOdometerFilterHidden: false,
      isYearFilterHidden: false,

      /* Save Search text */
      savedSearchName: '',
    };

    this.searchkit = new SearchkitManager(searchRoot, {searchOnLoad: true});
  }

  componentDidMount() {
    this.init();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('message', this.handleRecommendMessage);
    if (this.searchkit.state?.make?.length || this.searchkit.state?.make?.length) {
        this.setState({showRecommendedResults: true});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.loadLocation(prevProps);
    this.handleSortChange(prevState);
    this.handleView();
    this.checkForReconnect(prevProps);
    if (!this.state.isInitialLoaderRefreshed) {
      if (this.searchkit.hasHits()) {
        this.refreshDarwinLoader();
      }

    }
  }

  componentDidCatch(caughtError) {
    console.error(caughtError?.message || caughtError?.errorMessage || caughtError)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('message', this.handleRecommendMessage);
  }
  // #region Loaders
  init() {
    const mpId = getConfig('marketplaceId');
    this.props
      .loadMarketplaces(mpId)
      .then(this.loadMarketplaceSettings)
      .then(parentMarketplace => {
        this.addSearchKitListeners();
        this.addSearchKitDefaultQuery();
        this.loadLocation();
        this.loadStaticAggregations();
        this.loadStaticFilters(parentMarketplace);
        this.loadStaticSort(parentMarketplace);
        this.refreshDarwinLoader();
      })
      .catch(error => console.error(error));
  }

  checkForReconnect(prevProps) {
    if (
      (prevProps.onlineConnected === false &&
        this.props.onlineConnected === true) ||
      (prevProps.realTimeConnected === false &&
        this.props.realTimeConnected === true)
    ) {
      this.searchkit.reloadSearch();
    }
  }

  /** 
   * 
   * @param {()=>void} callback 
   */
  checkShouldDisplayContent(callback) {
    this.checkShouldDisplayResults(callback)
  }

  /**  Determine when initial search results should be displayed.
   *   Passed `callback` to ensure make/model state is capture first.
   * 
   * @param {()=>void} callback 
   */
  checkShouldDisplayResults(callback) {
    if (this.searchkit.state?.make?.length || this.searchkit.state?.make?.length) {
      const {make, model} = this.searchkit.state;
      if (!this.state.showRecommendedResults) {
        this.setState({
          showRecommendedResults: true, 
          recommendedMake: make || '', 
          recommendedModel: model || ''
        }, callback);

      } else {
        this.setState({
          recommendedMake: make || '', 
          recommendedModel: model || ''
        }, callback);
      }
    } else {
      callback();
    }
  }

  /**
   * When a search has 'no results', hide the collapsible panel
   *   'Odometer' (_mileage_) filter panel -- 
   *   unless a 'Trim'/'Odometer'/'Year' filter is selected -- as the 
   *   filter element is not displayed anyway.
   * 
   * @param {object} results
   * @param {'Trim'|'Odometer'|'Year'} panel
   * @todo (2025) Find an alternative for conditionally displaying 
   * filter panels.  This functionality is probably native to the library
   * by some means, but could not find it in the documentation.
   */
  checkShouldDisplayFilter = (results, panel) => {
    const trimOdoYearIdMap = {Odometer: 'mileage', Trim: 'series', Year: 'year'};
    const isFilterSelected = (this.searchkit.query?.index?.selectedFilters || [])
      .some(filterItem => filterItem?.id === trimOdoYearIdMap[panel]);
    const shouldHideFilter = 
      (results?.hits?.hits?.length === 0) 
      && !isFilterSelected;
    return shouldHideFilter;
  }

  getUpdatedSavedSearchName = (results) => {
    const autoFillFieldMap = {
      year: " by Year", 
      mileage: ", Odometer", 
      series: ", Trim"
    };
    const {userSelectedDistance} = this.state;
    const {make, model} = this.searchkit.state;
    let savedSearchName = `${todayDateText} BI Recommended - ${make} ${model}`.trim();

    const selectedQueryIds = (this.searchkit.query?.index?.selectedFilters || [])
      .map(selectedFilter => selectedFilter.id)
      .filter(id => id);
    const selectedFilters = [
      'year', 
      'mileage', 
      'series'
    ].filter(filterId => selectedQueryIds.includes(filterId)).map(fId => autoFillFieldMap[fId]);

    savedSearchName += (userSelectedDistance && userSelectedDistance !== ES_MAX_DISTANCE) 
      ? ` within ${userSelectedDistance}mi` 
      : '';
    savedSearchName += selectedFilters.join('');
    return savedSearchName;
  }

  addSearchKitListeners() {
    this.searchkit.addResultsListener(results => {
      this.loadScrollPosition();
      this.handleNavItems(results);
      this.loadStaticAggregations();
      this.refreshDarwinLoader(true);
      this.checkShouldDisplayResults(() => {
        const isTrimFilterHidden = this.checkShouldDisplayFilter(results, 'Trim');
        const isOdometerFilterHidden = this.checkShouldDisplayFilter(results, 'Odometer');
        const isYearFilterHidden = this.checkShouldDisplayFilter(results, 'Year')
        const savedSearchName = this.getUpdatedSavedSearchName(results);
        this.setState({isOdometerFilterHidden, isTrimFilterHidden, isYearFilterHidden, savedSearchName})
      });
    });
  }

  addSearchKitDefaultQuery() {
    // addDefaultQuery
    this.searchkit.addDefaultQuery(query => {
      const location = this.props.userSelectedLocation.location || {};
      const latitude = Number(location.lat);
      const longitude = Number(location.lng);
      const distanceUnits = findDistanceUnits(this.props.marketplaceFeatures);

      const queryObj = {
        bool: {
          must: [{ terms: { listingStatusId: this.state.listingStatusIds } }],
          must_not: [
            { terms: { eventId: this.props.unauthorizedEventIds || [] } },
            { range: { parentListingId: { gt: 0 } } }, // don't show bulk-lot children
          ],
          filter: [],
        },
      };

      if (this.isSortedByEndingSoonest()) {
        // this filters vehicles which have ended
        queryObj.bool.filter.push({
          range: {
            epochEndTime: {
              gte: moment().valueOf() - 28800000, // now minus 8 hours (diff btwn UTC and server time)lt: null,
            },
          },
        });
      }

      if (
        latitude &&
        longitude &&
        this.state.userSelectedDistance &&
        distanceUnits
      ) {
        // this filters by distance
        queryObj.bool.filter.push({
          geo_distance: {
            distance: `${this.state.userSelectedDistance}${distanceUnits}`,
            coordinates: {
              lat: latitude,
              lon: longitude,
            },
          },
        });
      }

      return query.addQuery(queryObj);
    });

    // setQueryProcessor
    this.searchkit.setQueryProcessor(plainQueryObject => {
      plainQueryObject.track_total_hits = true;

      const location = this.props.userSelectedLocation.location || {};
      const latitude = Number(location.lat);
      const longitude = Number(location.lng);

      // this adds distance to the hits
      const distanceUnits = findDistanceUnits(this.props.marketplaceFeatures);
      if (latitude && longitude && distanceUnits) {
        plainQueryObject.script_fields = {
          distance: {
            script: {
              source:
                "doc['coordinates'].planeDistance(params.lat,params.lon) * params.multiplier",
              params: {
                lat: latitude,
                lon: longitude,
                multiplier: distanceUnits === 'km' ? 0.001 : 0.00062137,
              },
            },
          },
        };
      }

      return plainQueryObject;
    });
  }

  handleDistanceSliderFinish = (newValue) => {
    const userSelectedDistance = typeof newValue === 'number' 
      ? String(newValue)
      : newValue;
    this.setState({ userSelectedDistance }, () => {
      this.searchkit.reloadSearch();
      this.props.loadUserSelectedDistance(
        userSelectedDistance
      );
    })
  }

  loadMarketplaceSettings = ({ response }) => {
    const mpId = getConfig('marketplaceId');
    if (response.wsStatus === 'Success') {
      const marketplace = find(
        response.marketplaceList,
        mp => mp.marketplaceId == mpId
      );

      if (marketplace) {
        return marketplace;
      }
    }
  };

  loadStaticAggregations() {
    const filters = get(this.searchkit, 'query.index.filters') || [];
    const eventNames = filters
      .filter(filter => filter.term && filter.term['eventName.raw'])
      .map(filter => filter.term['eventName.raw']);

    const body = {
      aggs: {
        all_inventory: {
          filter: {
            terms: { listingStatusId: [1, 2, 3, 4, 5, 6, 7, 8] },
          },
          aggs: {
            listingStatusId: { terms: { field: 'listingStatusId' } },
          },
        },

        available_inventory: {
          filter: {
            bool: {
              must: [
                { terms: { listingStatusId: this.state.listingStatusIds } },
              ],
              must_not: [
                { terms: { eventId: this.props.unauthorizedEventIds } },
              ],
            },
          },
          aggs: {},
        },
      },

      query: {
        bool: {
          filter: [],
        },
      },
    };

    if (eventNames && eventNames.length) {
      body.aggs.available_inventory.filter.bool.must.push({
        terms: { 'eventName.raw': eventNames },
      });
    }

    if (this.isSortedByEndingSoonest()) {
      body.query.bool.filter.push({
        range: { epochEndTime: { gte: moment().valueOf() - 28800000 } },
      });
    }

    ['year', 'mileage', 'outrightPrice', 'feedPrice', 'imageCount']
    .forEach(field => {
      body.aggs.available_inventory.aggs[field] = { stats: { field } };
    });

    this.props.loadAggregationsES(searchRoot, body).then(({ response }) => {
      const staticAggregations = response ? response.aggregations : {};
      this.setState({ staticAggregations });
    });
  }

  loadStaticFilters() {
    const staticFilterList = "8,9,6,7,15,22" // 'distance','year','make','model','odometer','trim'
      .split(',')
      .map(key => {
        const val = { ...mpSearchColumnsMap.get(key.trim()) };
        if (!val && key !== '0') {
          console.error(`mpSearchColumns does not contain key ${key}`);
        }
        return val;
      })
      .filter(filter => filter);

    this.setState({ staticFilterList });
  }

  loadStaticSort(marketplace) {
    const staticSortOptions = (
      marketplace.mpSortColumns && marketplace.mpSortColumns !== '0'
        ? marketplace.mpSortColumns
        : mpSortColumnsFallback
    )
      .split(',')
      .filter(key => !['4','5'].includes(key)) // exclude 'Make' / 'Model'
      .map(key => {
        const val = { ...mpSortOptionsMap.get(key.trim()) }; // don't mutate the map item!
        if (!val && key !== '0') {
          console.error(`mpSortColumns does not contain key ${key}`);
        }
        return val;
      });

    // check for stored sort option and check if valid
    // if valid set as default, else set the first option as default
    const storedDefaultSortOption = localStorage.getItem('recommendedDefaultSort');
    const storedDefaultSortOptionIndex = findIndex(staticSortOptions, {
      field: (storedDefaultSortOption || '_').split('_')[0],
      order: (storedDefaultSortOption || '_').split('_')[1],
    });

    let defaultSortOption = undefined;

    if (storedDefaultSortOptionIndex > -1) {
      defaultSortOption = storedDefaultSortOption;
      staticSortOptions[storedDefaultSortOptionIndex].defaultOption = true;
    }

    this.setState({
      defaultSortOption,
      staticSortOptions,
    });
  }

  /**
   * **New 2025.05** Init stratos scan with "message" call
   * - Tell StratosDealerEngine to scan for target element for attachment, once mounted
   * - Initial script init is handled in `TopNav.js`
   */
  refreshDarwinLoader (isVehicleValuesRefresh=false) {
    const stratosConfig = getConfig("stratosConfig");
    
    if (!stratosConfig) return;
  
    const darwinDataClassName = ".darwinVehicleData"
    const stratosElementClassName = isVehicleValuesRefresh 
      ? ".darwinVehicleButton" 
      : ".darwinDealerRecommended";

    try {
      const existingDataElement = document.querySelector(darwinDataClassName);
      const existingButtonElement = document.querySelector(stratosElementClassName);
      if (existingDataElement && existingButtonElement) {
        if (!this.state.isInitialLoaderRefreshed) {
          this.setState({isInitialLoaderRefreshed: true}, () => {
            postStratosMessage(stratosConfig, ".darwinDealerRecommended");
          });
        }
      }
    } catch (stratosInitError) {
      console.error(stratosInitError);
    }
  }

  findCategoryId() {
    return Number(get(this.searchkit, 'state.categories[0][0]'));
  }

  isSortedByEndingSoonest = () => {
    // and either the user has selected Ending Soonest sort *or*
    // it's the initial page load and the default sort is Ending Soonest
    return (
      get(this.searchkit, 'state.sort') === 'epochEndTime_asc' ||
      (!get(this.searchkit, 'state.sort') &&
        this.state.defaultSortOption === 'epochEndTime_asc')
    );
  };

  loadLocation(prevProps) {
    if (
      this.geoSuggest &&
      get(this.props, 'userSelectedLocation.address') !==
        get(prevProps, 'userSelectedLocation.address')
    ) {
      this.geoSuggest.update(this.props.userSelectedLocation.address || '');
    }
  }
  // #endregion Loaders
  // #region Handlers
  handleResize = (event) => {
    const isMobileDevice = window.matchMedia('(max-width: 800px)').matches;
    if (isMobileDevice !== this.state.isMobileDevice) {
      this.setState({isMobileDevice})
    }
  }

  handleDealerPanel = show => {
    this.setState({ showDealerPanel: show });
    // localStorage.setItem('showDealerPanel', show ? '1' : '0');
  };

  handleRecommendMessage = event => {
    const {recommendedQuery} = event.data;
    if (recommendedQuery && (recommendedQuery.make || recommendedQuery.model)) {
        const {make, model} = recommendedQuery;
        const searchParams = []
        if (make) searchParams.push(["make[0]", make]);
        if (model) searchParams.push(["model[0]", model]);
        const urlSearch = new URLSearchParams(searchParams);
        if (urlSearch.size) {
            const urlString = "?" + urlSearch.toString();
            this.props.history.push("recommended" + urlString);
            this.searchkit.searchFromUrlQuery(window.location.search);
        }
        if (this.state.isMobileDevice) {
          this.handleDealerPanel(false);
        }
        this.setState({recommendedMake: make, recommendedModel: model});
    }
  }

  loadScrollPosition = val => {
    const searchScroll =
      val || val === 0 ? val : sessionStorage.getItem('searchScroll');
    if (searchScroll || searchScroll === 0) {
      setTimeout(() => {
        window.scrollTo({ top: searchScroll });
      }, 0);
      sessionStorage.removeItem('searchScroll');
    }
  };

  handleSortChange = prevState => {
    const sortOption = get(this.searchkit, 'state.sort');

    if (sortOption && sortOption !== this.state.defaultSortOption) {
      this.setState({ defaultSortOption: sortOption });
      localStorage.setItem('recommendedDefaultSort', sortOption);
    }
  };

  handleView = () => {
    const view = get(this.searchkit, 'state.view');

    if (view && view !== this.state.defaultView) {
      this.setState({ defaultView: view });
    //   localStorage.setItem('defaultView', view);
    } 
  };

  handleBreadcrumbs = () => {
    // the navbar handles almost all the breadcrumbs, however isn't aware of any recommended page filters.
    // so the search page has to do a little work here to update the breadcrumbs regarding the filters
    const { pathname, search } = this.searchkit.history.location;
    const newBreadcrumbs = {
      path: '/recommended',
      crumbs: [{ text: 'Recommended', link: pathname + search }],
    };
    sessionStorage.setItem('bcCrumbs', JSON.stringify(newBreadcrumbs));
  };

  handleNavItems(results) {
    // typically nav items are handled when a user clicks a vehicle card (or Details button) to go to a VDP.
    // but we can't do that on recommended page vehicle cards so we do it here on results changes.
    sessionStorage.setItem('navItems', results.hits.ids || '');
  }

  handleUserSelectedLocation = data => {
    // user selected account location
    if (data.account) {
      this.props.loadUserSelectedLocation({
        key: 'account',
        location: data.location,
        address: data.label,
        city: data.account.city,
        state: findStateAbbreviation(data.account.state),
        zipcode: data.account.zipcode,
        accountId: data.account.accountId,
      });
    }
    // user selected some other location
    else {
      this.props.loadUserSelectedLocation({
        key: 'other',
        location: data.location,
        address: data.label,
      });
    }

    this.geoSuggest.update(data.label);
    this.searchkit.reloadSearch();
  };
  // #endregion Handlers
  resetDistanceAndLocation = () => {
    this.setState({ userSelectedDistance: ES_MAX_DISTANCE }, () => {
      this.geoSuggest && this.geoSuggest.update(this.props.userSelectedLocation.address || '');
      this.searchkit.reloadSearch();
      this.props.loadUserSelectedLocation({});
      this.props.loadUserSelectedDistance('');
    });
  };
  // #region Renderers
  renderAccountLocations() {
    // the account addresses will be at the top of the list a convenience to the user
    const accountListAddresses = get(
      this.props.userProfile,
      'user.accountList',
      []
    )
      .map(account => {
        // account must have city, state, AND zip to show up in list
        if (!account.city || !account.state || !account.zipcode) {
          return null;
        }

        // the "*" in the label keeps geo-suggest from suggesting locations too similar to these account locations
        // and we want the user to select the exact account location and not a similar one.
        // this is because when the user selects an account location the distance will match the transportation calculation distance
        const label = `* ${account.city}, ${findStateAbbreviation(
          account.state
        )} ${account.zipcode}`;

        return { className: 'fixtures', label, account };
      })
      .filter(fixture => fixture);

    return uniqBy(accountListAddresses, 'label');
  }

  renderDivider = () => {
    return (
      <hr 
        style={{
          borderColor: '#E5E5E5',
          width: '100%',
          alignSelf: 'center',
          marginTop: 5,
          marginBottom: 5,
        }}
      />
    )
  }

  renderResultsDefault() {
    return !this.state.showRecommendedResults 
        ? (
            <div className='recommended-results__default'>
                <h3>Results from Buyer Intelligence will appear below</h3>
            </div>
        )
        : null;
  }

  makeDistanceOptions() {
    const maxDistance = Number(ES_MAX_DISTANCE)
    const distanceUnits = findDistanceUnits(this.props.marketplaceFeatures);
    const distances = [maxDistance, 5, 10, 25, 50, 100, 250, 500, 1000, 2500];

    return distances.map((value, index) => ({
      key: index,
      value: String(value),
      label:
        value === maxDistance
          ? 'Any Distance'
          : `Within ${commafy(value)} ${distanceUnits}`,
    }));
  }

  makeDistanceValue() {
    const { userSelectedDistance } = this.state;
    const { marketplaceFeatures } = this.props;
    const units = findDistanceUnits(marketplaceFeatures);
    const label =
      userSelectedDistance === ES_MAX_DISTANCE
        ? 'Any Distance'
        : `${commafy(userSelectedDistance)} ${units}`;

    return {
      value: userSelectedDistance,
      label,
    };
  }
  // #region Filters

  /**
   * Returns list of Searchkit UI filter(s) as mapped in state via `staticFilterList`
   * @returns {React.JSX}
   */
  renderStaticFilters() {
    // this renders the static filters from a single list created by this.loadFilters().
    // static filters don't have a typeId
    return (this.state.staticFilterList || []).map((filterObj, index) => {
      const {
        collapsable = true,
        panel,
        typeId,
      } = filterObj;
      let filter = null;

      if (!typeId) {
        // static filters
        let {
          field = '',
          label,
          operator = 'OR',
          orderDirection = 'asc',
          orderKey = '_term',
          size = 10,
          title = '',
          translations = { '': 'Not Specified' },
        } = filterObj;
        let id = filterObj.id || field.replace('.raw', '');

        switch (panel) {
          case 'Distance': {
            filter = (
              <div>
                <div className="form-group">
                  <Geosuggest
                    ref={el => (this.geoSuggest = el)}
                    initialValue={this.props.userSelectedLocation.address || ''}
                    placeholder="Enter buyer location"
                    onFocus={() => this.geoSuggest.update(' ')}
                    onBlur={() => {
                      this.geoSuggest.update(
                        this.props.userSelectedLocation.address || ''
                      );
                    }}
                    fixtures={this.renderAccountLocations()}
                    autoComplete="true"
                    autoActivateFirstSuggest={false}
                    highlightMatch={true}
                    onSuggestSelect={this.handleUserSelectedLocation}
                    onSuggestNoResults={() => {}}
                    style={{
                      input: { fontSize: 16 },
                      suggests: { fontSize: 14 },
                      suggestItem: { fontSize: 14 },
                    }}
                  />
                </div>
                <div className="form-group"> 
                  <RangeSliderInputCustom 
                    onFinished={this.handleDistanceSliderFinish}
                    isActive={true}
                    isDisabled={!this.props.userSelectedLocation.key}
                    maxValue='2500'
                    marketplaceFeatures={this.props.marketplaceFeatures}
                    nextValue={this.state.dropdownSelectedDistance}
                    showLabel={true}
                    style={{padding: '0px', margin: '0px auto 10px'}}
                  />
                  <Select
                    id="searchDistance"
                    styles={dropdownStyle}
                    disabled={!this.props.userSelectedLocation.key}
                    options={this.makeDistanceOptions()}
                    value={this.makeDistanceValue()}
                    onChange={option => {
                      const userSelectedDistance = option.value;
                      const dropdownSelectedDistance = userSelectedDistance;
                      this.setState({ userSelectedDistance, dropdownSelectedDistance }, () => {
                        this.searchkit.reloadSearch();
                        this.props.loadUserSelectedDistance(
                          userSelectedDistance
                        );
                      });
                    }}
                  />
                </div>
                <div id="latLonDiv" className="hidden">
                  <MenuFilter
                    id="latLon"
                    field="latLon.raw"
                    title=""
                    operator="OR"
                    size={5000}
                    translations={{ All: 'All Locations' }}
                    listComponent={Select}
                  />
                  <MenuFilter
                    id="marketplaceId"
                    field="marketplaceId"
                    title=""
                    operator="OR"
                    size={5000}
                    translations={{ All: 'All Locations' }}
                    listComponent={Select}
                  />
                </div>
              </div>
            );
            break;
          }
          case 'Make':
          case 'Model':
            filter = (
                <RefinementListFilter
                  id={id}
                  field={field}
                  title={title}
                  orderKey={orderKey}
                  orderDirection={orderDirection}
                  operator={operator}
                  size={size}
                  translations={translations}
                />
            );
            break;

          case 'Body Style':
          case 'City':
          case 'Color':
          case 'Drive':
          case 'Engine':
          case 'Event':
          case 'Fuel Type':
          case 'Marketplace Type':
          case 'Options':
          case 'State':
          case 'Transmission': 
          case 'Trim': {
            filter = (
              <RefinementListFilter
                collapsable={collapsable}
                id={id}
                field={field}
                title={title}
                orderKey={orderKey}
                orderDirection={orderDirection}
                operator={operator}
                size={size}
                translations={translations}
              />
            );
            break;
          }

          case 'Odometer': {
            const stats = get(
              this.state.staticAggregations,
              `available_inventory[${field}]`
            ) || {min: 0, max: 400000};
            const min = stats.min || 0;
            let max = stats.max || 400000;
            if (min === max) max += 1; // if all items have same value there is no range and searchkit breaks

            filter = (
              <RangeFilter
                id={id}
                field={field}
                title=""
                min={min}
                max={max}
                rangeFormatter={commafy}
                rangeComponent={RangeSliderInput}
              />
            );
            break;
          }

          case 'Buy Now Price': {
            const stats = get(
              this.state.staticAggregations,
              `available_inventory[${field}]`
            );

            const min = stats.min || 0;
            let max = stats.max || Number(ES_MAX_DISTANCE);
            if (min === max) max += 1; // if all items have same value there is no range and searchkit breaks

            filter = (
              <div>
                <CheckboxFilter
                  id="hasPrice"
                  title=""
                  label="Has Buy Now Price"
                  // UPDATE 2025.04 - Exclude 'If-Sale' / 'Reserve' listings
                  filter={{
                    bool: {
                      must: [{ range: { [field]: {gt: 0} } }],
                      must_not: [{ term: { isReserveUnit: true } }]
                    }
                  }}
                />
                <RangeFilter
                  id="outRightPrice"
                  field={field}
                  title=""
                  min={min}
                  max={max}
                  rangeFormatter={commafyCurrency}
                  rangeComponent={RangeSliderInput}
                />
              </div>
            );

            break;
          }

          case 'Year': {
            const stats = get(
              this.state.staticAggregations,
              `available_inventory[${field}]`
            ) || {min: 1980, max: 2024};
            const min = stats.min;
            let max = stats.max;
            if (min === max) max += 1; // if all items have same value there is no range and searchkit breaks

            filter = (
              <RangeFilter
                id={id}
                field={field}
                title=""
                min={min}
                max={max}
                rangeComponent={RangeSliderInput}
              />
            );
            break;
          }

          case 'Location': {
            filter = (
              <MenuFilter
                id={id}
                field={field}
                title={title}
                operator={operator}
                size={size}
                translations={translations}
                listComponent={Select}
              />
            );
            break;
          }

          default: {
            break;
          }
        }
      }
      
      const isDisabled = (
        (['Make','Model'].includes(panel)) 
        || (panel === 'Trim' && this.state.isTrimFilterHidden) 
        || (panel === 'Odometer' && this.state.isOdometerFilterHidden)
        || (panel === 'Year' && this.state.isYearFilterHidden)
      )
      const showDivider = 
        !isDisabled
        && (index !== (this.state.staticFilterList.length - 1))
        && (!['Make','Model'].includes(panel))

      return filter !== null ? (
        <div key={index}>
          <Panel
            key={filterObj.id || filterObj.field.replace('.raw','')}
            collapsable={true}
            disabled={isDisabled}
            defaultCollapsed={true}
            title={panel}
          >
            {filter}
          </Panel>
          {showDivider ? (this.renderDivider()) : null}
        </div>
      ) : null;
    });
  }

  // #endregion Filters
  // #region Results
  // NOTE: - here is the list you are always looking for
  renderResults() {
    return (
      <ViewSwitcherHits
        className={this.state.showRecommendedResults ? '' : 'recommended-results__hidden'}
        hitsPerPage={10}
        sourceFilter={[
          'aged',
          'announcements',
          'attributes', // ari
          'attributeValues', // ari
          'bidIncrement',
          'bodyStyle', // disabled until data cleaned up
          'categories', // ari
          'city',
          'coordinates',
          'description',
          'distance',
          'script_fields',
          'geo_distance',
          'drive',
          'endDate',
          'engine',
          'epochEndTime',
          'epochStartTime',
          'eventFeatures',
          'eventId',
          'eventName',
          'eventTypeId',
          'exteriorColor',
          'factoryColor',
          'featured',
          'feedPrice',
          'fuelType',
          'hasBidOrOffer',
          'hasCR',
          'hasImage',
          'highBid',
          'highOffer',
          'highBidderAccountId',
          'id',
          'imageCount',
          'images',
          'isMPSellingLive',
          'isPrivateEvent',
          'isReserveUnit',
          'itemCity',
          'itemPostalCode',
          'itemState',
          'latitude',
          'latLon',
          'licenseNumber',
          'lights',
          'listingStatus',
          'listingStatusId',
          'listingTypeId',
          'liveStartTime',
          'longitude',
          'lotNumber',
          'mainImage',
          'make',
          'marketplaceFeatures',
          'marketplaceId',
          'marketplaceName',
          'marketplaceType',
          'mileage',
          'mileageDesc',
          'model',
          'name',
          'notes',
          'options',
          'outrightPrice',
          'preAged',
          'privateEvent',
          'rating',
          'ratingValue',
          'retailBookValue',
          'sellerName',
          'series',
          'startDate',
          'startingBid',
          'state',
          'stockNumber',
          'transmission',
          'vIN',
          'wholesaleBookValue',
          'year',
          'hasSubListings',
          'subItemDetails',
          'bulkLotDescription',
        ]}
        hitComponents={[
          {
            key: 'list',
            title: 'List',
            itemComponent: <ListItem showVehicleValuesData={true} showVehicleValuesButton={this.state.showVehicleValuesButton} />,
            defaultOption: true,// this.state.defaultView === 'list',
          },
        ]}
      />
    );
  }

  renderNoResults() {
    const {savedSearchName} = this.state;
    return (
      <div style={{margin: '0 auto', width: '100%'}}>
        <NoHits
          component={props => (
            <>
              <NoHitsDisplayCustom
                {...props}
                searchkit={this.searchkit}
                defaultSortOption={this.state.defaultSortOption}
                isSortedByEndingSoonest={this.isSortedByEndingSoonest}
                resetDistanceAndLocation={this.resetDistanceAndLocation}
              />
              {this.renderSaveSearchButton(savedSearchName, 'link')}
            </>
          )}
        />
      </div>
    );
  }
  // #endregion Results
  // #region Panels
  renderRecommendedSearchPanel() {
    const {showDealerPanel} = this.state;
    return (
      <div
        className={
        `recommended-sidebar${showDealerPanel ? '' : ' recommended-sidebar-hide'}`
        }
      >
        {this.state.isMobileDevice ? this.renderSearchPanelHide() : null}
        <div>
          <div className='darwinDealerRecommended' />
          {/* <StratosLoaderDummyData accountList={this.props.userProfile?.user?.accountList} /> */}
        </div>
      </div>
    )
  }

  renderSort() {
    const options = this.state.staticSortOptions;

    if (!options) return null;

    return (
      <SortingSelector
        
        options={options}
        listComponent={props => (
          <SearchKitSelect
            {...props}
            disabled={!this.state.showRecommendedResults}
            sort={get(this.searchkit, 'state.sort')}
          />
        )}
      />
    );
  }

  renderResultsStats() {
    return this.state.showRecommendedResults ? (
      <HitsStats
        component={props => (
            <HitStatsCustom 
            {...props} 
            searchkit={this.searchkit} 
          />
        )}
        translations={{
          'hitstats.results_found': '{hitCount} results found',
        }}
      />
    ) : null;
  }

  renderSearchPanelHide = () => {
    return (
      <div className="sk-toggle" style={{float: 'right'}}>
        <div
            className={
              !this.state.showDealerPanel
                ? 'sk-toggle-option sk-toggle__item is-active'
                : 'sk-toggle-option sk-toggle__item'
            }
            onClick={() => this.handleDealerPanel(false)}
            style={{ padding: '4px 8px' }}
          >
            <div className="sk-toggle-option__text">
              <i className="fa fa-search-minus" /> Hide
            </div>
          </div>
      </div>
    )
  }

  renderSearchPanelShow = () => {
    return (!this.state.showDealerPanel)
    ? (
      <div className="sk-toggle">
        <div
            className={'sk-toggle-option sk-toggle__item'}
            onClick={() => this.handleDealerPanel(true)}
            style={{ padding: '4px 8px' }}
          >
            <div className="sk-toggle-option__text">
              <i className="fa fa-search-plus" /> Show Recommended
            </div>
          </div>
      </div>
    ) : null;
  }

  renderSaveSearchButton(savedSearchName, buttonType) {
    const savedSearchButtonStyles = { display: 'inline', float: 'left' };
    const savedSearchLinkStyles = { width: '100%', textAlign: 'center', margin: '0 auto' };
    const {recommendedMake: make, recommendedModel: model, userSelectedDistance} = this.state;
    const searchResultsCount = this.searchkit.results?.hits?.total?.value;
    const postFilter = this.searchkit?.query?.query?.post_filter;
    return (make || model)
    ? (
      <div style={buttonType === 'link' ? savedSearchLinkStyles : savedSearchButtonStyles}>
        <WishlistButton
          additionalText={buttonType === 'link' 
              ? 'You can save the search and be notified when these vehicles are available.' 
              : null
          }
          buttonType={buttonType}
          location={this.props.location}
          searchResultsCount={searchResultsCount}
          postFilter={postFilter}
          savedSearchName={savedSearchName || this.state.savedSearchName}
          userSelectedDistance={userSelectedDistance}
          userSelectedLocation={this.props.userSelectedLocation}
          // customText={"Quick Save"}
        />
      </div>
    ) : null;
  }

  renderSelectedDistanceFilter() {
    // NOTE: - this is a faux filter
    if (
      isEmpty(this.props.userSelectedLocation) ||
      this.state.userSelectedDistance === ES_MAX_DISTANCE
    )
      return null;

    const dist = this.state.userSelectedDistance;
    const loc = this.props.userSelectedLocation.address;
    const units = findDistanceUnits(this.props.marketplaceFeatures);
    const text = `${dist} ${units} from ${loc}`;

    return (
      <div className="sk-selected-filters-option sk-selected-filters__item">
        <div className="sk-selected-filters-option__name">{text}</div>
        <div
          className="sk-selected-filters-option__remove-action"
          onClick={this.resetDistanceAndLocation}
        >
          x
        </div>
      </div>
    );
  }

  // #endregion Panels
  renderSelectedFilters() {
    return (
      <div className="sk-selected-filters-container">
        <SelectedFilters
          itemComponent={props =>
            <SelectedFilterCustom
              {...props}
              userSelectedDistance={this.state.userSelectedDistance}
              userSelectedLocation={this.props.userSelectedLocation}
              showRemoveButton={!["make","model"].includes(props.filterId)}
            />
          }
        />
        {this.renderSelectedDistanceFilter()}
      </div>
    );
  }

  renderClearAllFiltersButton() {
    return (
      <ResetFilters
        component={props => (
          <ResetFiltersDisplayCustom
            {...props}
            userSelectedDistance={this.state.userSelectedDistance}
            resetDistanceAndLocation={this.resetDistanceAndLocation}
            searchkit={this.searchkit}
            sort={get(this.searchkit, 'state.sort')}
          />
        )}
      />
    );
  }

  /**
   * 
   * @param {'top'|'bottom'} position 
   */
  renderPagination(position) {
    return this.state.showRecommendedResults 
      ? (
          <ActionBarRow>
            <PageSizeSelector options={[10,25,35,50]}/>
            <Pagination showNumbers={true} pageScope={3} /> 
          </ActionBarRow>
        )
      : null;
  }
  
  render() {
    if (
      !this.props.userProfile.user ||
      !this.searchkit ||
      (!this.state.staticAggregations && !this.state.staticFilterList)
    ) {
      return null;
    }
    const {savedSearchName} = this.state;
    return (
      <SearchkitProvider searchkit={this.searchkit}>
        <Layout size="l">
          <LayoutBody>
            <div className={'recommended-wrapper'}>
              {this.renderRecommendedSearchPanel()}
              <div
                id="searchContainer"
                className={'search-content recommended-content'}
                >
                  <Panel 
                    collapsable={true} 
                    defaultCollapsed={true} 
                    disabled={!this.state.showRecommendedResults}
                    className='sk-panel__recommended'
                    title='Filters' 
                  >
                    <div 
                      style={{width: '100%', margin: '0 auto', padding: 10}}
                    >
                      {this.renderStaticFilters()}
                    </div>
                  </Panel>
                  <LayoutResults>
                    <ActionBar>
                      <div
                        className='recommended-toolbar__container'
                      >
                        <ActionBarRow>
                          <div className='recommended-toolbar__selected' >
                            {this.renderSelectedFilters()}
                            {this.renderSaveSearchButton(savedSearchName)}
                          </div>
                        </ActionBarRow>
                        <ActionBarRow>
                          <div className='recommended-toolbar__sort-stats' >
                            {this.renderSearchPanelShow()}
                            {this.renderResultsStats()}
                            {this.renderSort()}
                          </div>
                        </ActionBarRow>
                      </div>
                    </ActionBar>
                    {this.renderResultsDefault()}
                    {this.renderResults()}
                    {this.renderNoResults()}
                    <InitialLoader />
                    <ActionBar>
                      {this.renderPagination()}
                    </ActionBar>
                  </LayoutResults>
              </div>
            </div>
          </LayoutBody>
        </Layout>
      </SearchkitProvider>
    );
  }
  //#endregion Renderers
}
// #region Redux
const mapStateToProps = state => {
  const {
    attributes,
    categories,
    geocode,
    listingStatusIds,
    marketplaceFeatures,
    userItems,
    userProfile,
    userSelectedDistance,
    userSelectedLocation,
    unauthorizedEventIds,
    onlineConnected,
    realTimeConnected,
    watchlistObject,
  } = state.entities;
  return {
    attributes,
    categories,
    geocode,
    listingStatusIds,
    marketplaceFeatures,
    userItems,
    userProfile,
    userSelectedDistance,
    userSelectedLocation,
    unauthorizedEventIds,
    onlineConnected,
    realTimeConnected,
    watchlistObject,
  };
};
// #endregion Redux
export default connect(mapStateToProps, {
  loadAggregationsES,
  loadAttributes,
  loadCategories,
  loadMarketplaces,
  loadUserSelectedDistance,
  loadUserSelectedLocation,
})(Recommended);


